import { call, select, put } from 'redux-saga/effects';

import { SAVE_SETTINGS, DISPATCH_HACK } from '@lib/actions/actionTypes';
import settingsResource from '@lib/resources/settingsResource';
import { selectCurrentUser } from '@lib/selectors';

import sagaFetch from './sagaFetch';

// bind resource generators
const save = sagaFetch.bind(null, SAVE_SETTINGS, settingsResource.save);

// This is to get the correct id instead of always the master
function getUserSettingId({ master, setting, userSetting }) {
  return master ? setting : userSetting;
}

export default function* sagaSaveSettings(action) {
  // suppressNotification avoid the snackbar when saving setting from showing
  // strictMode checks if it should use the master setting to save or the current user setting id
  const { data, suppressNotification, strictMode, onSuccess, onError } = action;
  const currentUser = yield select(selectCurrentUser);
  const id = strictMode ? getUserSettingId(currentUser) : currentUser.setting;
  const res = yield call(save, { id, data });
  if (res.error) {
    onError?.(res.error);
  } else {
    onSuccess?.(res);
  }
  if (!res.error && !suppressNotification) {
    yield put({ type: DISPATCH_HACK, notification: 'Settings saved successfully!' });
  }
  return res;
}
